import React from 'react'
import { Input, NumberInput, Radio, Tooltip } from '@mantine/core'
// import { JsonEditor } from 'jsoneditor-react'
import { IconMaps } from '@ow/icons'
import CheckComp from '../components/Check'
import TitleComp from '../components/Title'
import ErrorTip from '../components/errorTip'
import BasicSettings from '../components/BasicSettings'
// import ErrorTip from '../components/errorTip'

const Render = function ({
  watch,
  register,
  errors,
  getValues,
  control,
  Controller,
}) {
  const rule = {
    maxLength: {
      value: 8,
      message: '不可超过8个字符',
    },
  }

  const decimalDigits = watch('decimalDigits')

  return (
    <>
      {/* 引入通用设置 */}
      <BasicSettings register={register}>
        <TitleComp title="提示">
          <Input {...register('hint')} />
        </TitleComp>
        <TitleComp title="单位">
          <Input {...register('unit', rule)} />
        </TitleComp>
        {errors.unit && <ErrorTip errorMessage={errors.unit.message} />}
        <TitleComp title="保留小数位数">
          <Controller
            name="decimalDigits"
            control={control}
            render={({ field }) => {
              return <NumberInput {...field} min={0} />
            }}
          />
        </TitleComp>
        <TitleComp title="默认值">
          <Controller
            name="defaultValue"
            control={control}
            render={({ field }) => {
              return (
                <NumberInput
                  {...field}
                  precision={decimalDigits}
                  min={getValues('min')}
                  max={getValues('max')}
                />
              )
            }}
          />
        </TitleComp>
        <TitleComp title="设置">
          <Controller
            name="showType"
            control={control}
            render={({ field }) => {
              return (
                <Radio.Group
                  styles={{
                    label: { color: 'var(--ow-color-gray-100)' },
                  }}
                  size="sm"
                  required
                  {...field}
                >
                  <Radio
                    value="thousandSeparator"
                    label={
                      <div className="flex items-center">
                        <span>显示千位分隔符</span>
                        <Tooltip
                          wrapLines
                          withArrow
                          transition="fade"
                          transitionDuration={200}
                          label="示例：1,000,000，与显示百分比互斥"
                        >
                          <div>
                            <IconMaps type="whiteBgHelp" />
                          </div>
                        </Tooltip>
                      </div>
                    }
                  />
                  <Radio
                    value="percent"
                    label={
                      <div className="flex items-center">
                        <span>显示百分比</span>
                        <Tooltip
                          wrapLines
                          withArrow
                          transition="fade"
                          transitionDuration={200}
                          label="示例：69.12%，与显示千位分隔符互斥"
                        >
                          <div>
                            <IconMaps type="whiteBgHelp" />
                          </div>
                        </Tooltip>
                      </div>
                    }
                  />
                </Radio.Group>
              )
            }}
          />
        </TitleComp>
        <TitleComp title="校验">
          <CheckComp
            register={register}
            registerName="required"
            // defaultValue={require}
            label="必填"
          />
          <CheckComp
            register={register}
            registerName="rangeSetting"
            label="是否限制大小"
          />
          {watch('rangeSetting') && (
            <div className="flex  w-full">
              <div className="flex items-center ">
                <div className="mr-2">最小值</div>
                <Controller
                  name="min"
                  control={control}
                  render={({ field }) => {
                    return (
                      <NumberInput
                        {...field}
                        styles={{
                          input: { width: '100px' },
                        }}
                        precision={decimalDigits}
                        placeholder="请填入最小限制"
                        min={0}
                        max={getValues('max') && getValues('max') - 1}
                        required
                      />
                    )
                  }}
                />
              </div>

              <div className="flex items-center ml-4">
                <div className="mr-2">最大值</div>
                <Controller
                  name="max"
                  control={control}
                  render={({ field }) => {
                    return (
                      <NumberInput
                        {...field}
                        styles={{
                          input: { width: '100px' },
                        }}
                        precision={decimalDigits}
                        placeholder="请填入最大限制"
                        min={getValues('min') && getValues('min') + 1}
                        required
                      />
                    )
                  }}
                />
              </div>
            </div>
          )}
        </TitleComp>
        {/* <TitleComp title="提示">
          <Controller
            name="code"
            control={control}
            render={({ field }) => {
              return <JsonEditor {...field} style={{ height: '300px' }} />
            }}
          />
        </TitleComp> */}
      </BasicSettings>

      {/* <TitleComp title="输入方式">
        <Controller
          name="render"
          control={control}
          render={({ field }) => {
            return (
              <RadioGroup
                styles={{
                  label: { color: 'var(--ow-color-gray-100)' },
                }}
                size="sm"
                required
                {...field}
              >
                <Radio value="input" label="数值" />
                <Radio value="slider" label="进度" />
              </RadioGroup>
            )
          }}
        />
      </TitleComp> */}
    </>
  )
}

export default Render
